import { createModel } from '@/store/tools';

const model = {
    namespace: 'reporttemplate',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getStateList': T('getStateList'),
            'getTableSource': T('getTableSource'),
            'getTemplateDetail': T('getTemplateDetail'),
        },
        actions: {
            'getStateList': A('getStateList'),
            'getTableSource': A('getTableSource'),
            'getTemplateDetail': A('getTemplateDetail'),
            'getCleanDetail': C('getTemplateDetail'), // 清除详情数据
        },
        sagas: {
            'getStateList': S('getStateList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getTableSource': S('getTableSource', '/?cmd=com.xqxc.api.pig.mis.biz.platform.report.ReportTemplateService.list'),
            'getTemplateDetail': S('getTemplateDetail', '/?cmd=com.xqxc.api.pig.mis.biz.platform.report.ReportTemplateService.info'),
        },
        reducers: {
            'stateList': R('getStateList', []),
            'tableSource': R('getTableSource', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'templateDetail': R('getTemplateDetail', { queryCriteriaList: [] }),
        }
    })
};
export default createModel(model);